/*
import axios from 'axios'
import config from '../settings/bananas'

const header = {
  'Content-Type': 'application/json'
}

let trackingUrl = config.tracking.url

if (window.location.hostname === 'localhost') {
  trackingUrl = 'http://localhost:3000'
}
*/

export default {
  trackAction(actionData, instance) {
    /*
    actionData.userId = instance.$store.getters.getUniqueId
    actionData.firstInteraction = instance.$store.getters.getFirstInteraction
    instance.$store.dispatch('updateFirstInteraction')
    axios.post(
      trackingUrl + '/tracking/bn/action/',
      actionData,
      {
        headers: header
      }
    ).then(function (response) {
      return response.data
    })
    */
  },
  getAllActions() {
    /*
    axios.post(
      trackingUrl + '/tracking/bn/action/get/all',
      {},
      {
        headers: header
      }
    ).then(function (response) {
      return response.data
    })
    */
  }
}
